@for (field of normalizedFields(); track field) {
    <div>
        <div class="ft-label" [innerHTML]="field.label || ''"></div>
        <ft-code-mirror class="ft-code-field_host"
                        [attr.data-field]="field.name"
                        [language]="syntax()"
                        (ready)="onEditorReady($event, field.name)"
                        (docChange)="onDocChange(field.name, $event)" />
        <input class="ng-hide" type="checkbox" />
    </div>
}
